import React from 'react';
import Profile from '../container/Profile'

import { cleanAreaData } from '../../utils/cleanRawData'
import constructName from '../../utils/constructName'
import '../../styles/custom.css'
import '../../styles/iconos.css'

export default ({ result }) =>{

    const isDataEmpy= ( data )=>{
        if( !!data && data !=='null' && data.toLowerCase() !== "n/a" && data.toLowerCase() !== "n" ){
            return false
        }else{
            return true
        }
    }
    return(
    
        <li className="sui-result contenedor-investigador" 
            style={{
                margin: '10px auto',
                textAlign: 'center',
            }}>
                <div className="cabezera-investigador">
                    <img
                        className="imagen-cabezera-investigador"
                        src={ `/avatar/${result.rut?.snippet}.jpg` }
                        onError={ (e)=> {e.target.onerror = null; e.target.src="https://external-content.duckduckgo.com/iu/?u=http%3A%2F%2Fzancada.com%2Fwp-content%2Fimagenes%2F2012%2F12%2Ffacebook-profile-picture-n-copy.jpg&f=1&nofb=1"} } 
                        alt="foto del investigador" 
                        title="foto investigador" 
                    />
                    <span className="texto-cabezera"
                        
                        dangerouslySetInnerHTML={{__html: constructName(result)}}>
                    </span>
                </div>
                
                <div className="sui-result__body">
                    
                    <ul className="sui-result__details" 
                        style={{
                            margin: '0px 5%',
                            textAlign: 'left'
                            }}>
                        {/*<li>
                            <span className="sui-result__key">Email:</span>
                            <span className="sui-result__value"
                            dangerouslySetInnerHTML={{__html: result.email?.snippet}}
                            ></span>
                        </li>*/}
                    
                        <li>
                            <span className="sui-result__key">Universidad:</span>
                            <span className="sui-result__value"
                            dangerouslySetInnerHTML={{__html: result.universidad?.snippet}}
                            ></span>
                        </li>
                        {
                            !isDataEmpy(result.facultad?.raw)  && (
                                <li>
                                    <span className="sui-result__key">Facultad:</span>
                                    {
                                        // eslint-disable-next-line
                                        <a className="sui-result__value_centro sui-result__value" rel="noopener noreferrer" target="_blank">{result.facultad?.raw}</a>
                                    }
                                </li>
                            )
                        }

                        {
                            ( !isDataEmpy(result.centro.raw) && !isDataEmpy(result.link_centro.raw) && !isDataEmpy(result.centro.snippet) ) && (
                                <li>
                                    <span className="sui-result__key">Centro:</span>
                                    <a className="sui-result__value_centro sui-result__value" href={result.link_centro.raw} rel="noopener noreferrer" target="_blank">{result.centro?.raw}</a>
                                </li>
                            )
                        }

                        {
                            (!!result.area_de_expertise?.snippet )  && (
                                <li>
                                    <span className="sui-result__key">Área de expertise:</span>
                                    <span className="sui-result__value"
                                    dangerouslySetInnerHTML={{__html: cleanAreaData(result.area_de_expertise)}}
                                    ></span>
                                </li>

                            )
                        }
   
                    </ul>
                </div>
                <div className="sui-result__footer">
                    <Profile data={result}/>
                </div>

        </li> 
    )
};